import { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import api from "../Authentication/authService";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelector } from "react-redux";
import ProfileSkeleton from "../Skeleton/ProfileSkeleton";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { PaymentStatus } from "../../context/PaymentStatusSlice";
import { CONFIG } from "../../config";


const Profile = () => {
  const [loading, setLoading] = useState(true);
  const [isEmailError, setIsEmailError] = useState("");
  const [isPhoneError, setIsPhoneError] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [isUpdateInfoOpenModel, setIsUpdateInfoOpenModel] = useState(false);
  const [oldEmail, setOldEmail] = useState("");
  const [oldPhone, setOldPhone] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [customerRights, setCustomerRights] = useState([
    {
      regular_Notice: "",
      soL_Notice: "",
      privacy_Link: "",
      privacyFlag: false,
    },
  ]);
  const [isSolNoticeModalOpen, setIsSolNoticeModalOpen] = useState(false);
  const [isPrivacyOpenModel, setIsPrivacyOpenModel] = useState(false);
  const updateRequestModelRef = useRef(null);
  const { paymentStatus, paymentPlanStatus, actualBalance, merchantStatus } =
    useSelector((state) => state.PaymentStatus);
  const [isRightsModalOpenTwo, setIsRightsModalOpenTwo] = useState(false);
  const [isRightsModalOpen, setIsRightsModalOpen] = useState(false);
  const location = useLocation();
  const [isEconsentModalOpen, setIsEconsentModalOpen] = useState(false);
  const [isCCPAModalOpen, setIsCCPAModalOpen] = useState(false);

  const [submitDisabled, setSubmitDisabled] = useState(false);
  const rightsModalRefTwo = useRef(null);
  const updateInfoRef = useRef(null);
  const econsentInfoRef = useRef(null);
  const solModalRef = useRef(null);
  const [actionType, setActionType] = useState("");

  const [isSubmitVisible, setIsSubmitVisible] = useState(true);
  const [selectedFields, setSelectedFields] = useState([]);
  const [formValues, setFormValues] = useState({});
  const inputRefs = useRef({});

  const apiUrl = CONFIG.REACT_APP_API_BASE_URL;;
  const MySwal = withReactContent(Swal);
  const [AccountInfo, setAccountInfo] = useState({
    accountOpenDate: null,
    credenceAccountNumber: "",
    creditorName: "",
    currentBalance: 0,
    customerEmail: "",
    dateOfService: "",
    firstName: "",
    lastName: "",
    originalCreditorName: null,
    setBalance: 0,
    settlementAmount: 0,
    zip: "",
    state: "",
    disconnectedDate: null,
    collectionType: null,
    channelFlag: "",
  });
  const { CredenceAccountNumber } = useSelector(
    (state) => state.Authentication,
  );
  useEffect(() => {
    if (isCCPAModalOpen || isEconsentModalOpen) {
      document.body.style.scrollBehavior = "auto";
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = "15px";
    } else {
      document.body.style.scrollBehavior = "";
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    }

    return () => {
      document.body.style.scrollBehavior = "";
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    };
  }, [isCCPAModalOpen, isEconsentModalOpen]);
// useEffect(() => {
//   if (!location.state?.scrollTo) return;

//   const interval = setInterval(() => {
//     const section = document.getElementById(
//       location.state.scrollTo
//     );

//     if (section) {
//       section.scrollIntoView({ behavior: "auto" });
//       clearInterval(interval);
//     }
//   }, 100);

//   return () => clearInterval(interval);
// }, [location.key]);
const today = new Date();

const formattedDate = today.toLocaleDateString('en-US', {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric',
});
useLayoutEffect(() => {
  if (loading) return;
  if (!location.state?.scrollTo) return;

  const section = document.getElementById(location.state.scrollTo);
  if (section) {
    section.scrollIntoView({ behavior: "auto", block: "start" });
  }
}, [loading, location.key]);


  const handleInputChange = (e) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const { name, value } = e.target;

    if (name === "UserEmail") {
      setEmail(value);
      if (emailRegex.test(value)) {
        setIsEmailError("");
        setIsSubmitVisible(value === oldEmail);
      } else {
        setIsSubmitVisible(true);
        setIsEmailError("Invalid EmailID");
      }
    } else if (name === "UserPhone") {
      setPhone(value);
      if (isNaN(value) || value.trim() === "" || value?.length !== 10) {
        setIsSubmitVisible(true);
        setIsPhoneError("Invalid Phone Number");
      } else {
        setIsSubmitVisible(value === oldEmail);
        setIsPhoneError("");
      }
    }

    setSubmitDisabled(false);
  };
  const handleUpdateRequestCloseModel = () => {
    setIsCCPAModalOpen(false);
  };
  const setInputRef = (key, el) => {
    if (el) inputRefs.current[key] = el;
  };

  const handleInputChangeForFields = useCallback((field, value) => {
    setFormValues((prev) => ({
      ...prev,
      [field]: value,
    }));

    setTimeout(() => {
      const ref = inputRefs.current[field];
      if (ref && document.activeElement !== ref) {
        ref.focus();

        if (ref.tagName.toLowerCase() === "textarea") {
          const length = ref.value?.length;
          ref.setSelectionRange(length, length);
        } else {
          const supportedTypes = ["text", "search", "tel", "url", "password"];
          if (ref.setSelectionRange && supportedTypes.includes(ref.type)) {
            const length = ref.value?.length;
            ref.setSelectionRange(length, length);
          }
        }
      }
    }, 0);
  }, []);
  const handleActionChange = (e) => {
    const val = e.target.value;
    setActionType(val);
    setSelectedFields([]);
    setFormValues({});
  };
  const fieldsMap = {
    firstname: {
      label: "First Name",
      type: "text",
      placeholder: "Update First Name",
      name: "ForFirstName",
    },
    midname: {
      label: "Middle Name",
      type: "text",
      placeholder: "Update Middle Name",
      name: "ForMidName",
    },
    lastname: {
      label: "Last Name",
      type: "text",
      placeholder: "Update Last Name",
      name: "ForLastName",
    },
    phone: {
      label: "Phone Number",
      type: "tel",
      placeholder: "Update Phone Number",
      name: "ForPhone",
    },
    address1: {
      label: "Address line 1",
      type: "text",
      placeholder: "Update Address Line 1",
      name: "ForAddress1",
    },
    address2: {
      label: "Address line 2",
      type: "text",
      placeholder: "Update Address Line 2",
      name: "ForAddress2",
    },
    city: {
      label: "City",
      type: "text",
      placeholder: "Update City",
      name: "ForCity",
    },
    state: {
      label: "State",
      type: "text",
      placeholder: "Update State",
      name: "ForState",
    },
    zip: {
      label: "Zip",
      type: "number",
      placeholder: "Update Zip",
      name: "ForZip",
    },
    email: {
      label: "Email",
      type: "email",
      placeholder: "Update Email address",
      name: "ForEmail",
    },
    ip: {
      label: "IP Address",
      type: "text",
      placeholder: "Update IP Address",
      name: "ForIp",
    },
    ssn: {
      label: "Social Security Number",
      type: "text",
      placeholder: "Update SSN Number",
      name: "ForSSN",
    },
    other: {
      label: "Other",
      type: "textarea",
      placeholder: "Specify Here",
      name: "ForOther",
    },
  };
  const fieldOptions = [
    { value: "all", label: "All" },
    { value: "firstname", label: "First Name" },
    { value: "midname", label: "Middle Name" },
    { value: "lastname", label: "Last Name" },
    { value: "phone", label: "Phone Number" },
    { value: "address1", label: "Address" },
    // { value: 'address2', label: 'Address Line 2' },
    // { value: 'city', label: 'City' },
    // { value: 'state', label: 'State' },
    // { value: 'zip', label: 'Zip Code' },
    { value: "email", label: "Email Address" },
    { value: "ip", label: "IP Address" },
    { value: "ssn", label: "SSN" },
    { value: "other", label: "Other" },
  ];
  const handleUpdateInfoOpenModel = () => {
    setIsUpdateInfoOpenModel(true);
  };
  const handleUpdateInfoCloseModel = () => {
    setIsUpdateInfoOpenModel(false);
    // setPhone("");
    // setEmail("");

    setIsEmailError("");
    setIsPhoneError("");
  };
  const UpdateData = {
    emailID: email,
    credenceAccountNumber: CredenceAccountNumber,
    phoneNumber: phone,
    emailAddFlag: oldEmail == email ? false : true,
    phoneFlag: oldPhone == phone ? false : true,
  };
  // const formatDate = (dateStr) => {
  //   if (!dateStr || typeof dateStr !== "string") return "N/A";

  //   const parts = dateStr.split("/");
  //   if (parts.length !== 3) return dateStr;

  //   const [day, month, year] = parts;
  //   const date = new Date(`${year}-${month}-${day}`);

  //   return date.toLocaleDateString("en-US", {
  //     month: "short",
  //     day: "numeric",
  //     year: "numeric",
  //   });
  // };
  const formatDate = (dateStr) => {
  if (!dateStr || typeof dateStr !== "string") return "N/A";

  const parts = dateStr.split("/");
  if (parts.length !== 3) return dateStr;

  const [day, month, year] = parts;
  

  const date = new Date(Date.UTC(year, month - 1, day)); 

  
  const formatter = new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC", 
  });

  return formatter.format(date);
};

  const handleSubmit = () => {
    if (!actionType) {
      alert("Please select an action");
      return;
    }

    const customerUpdateFields =
      actionType === "correct"
        ? {
            isFirstNameUpdated: false,
            isMiddleNameUpdated: false,
            isLastNameUpdated: false,
            isPhoneNumberUpdated: false,
            isAddressLine1Updated: false,
            isAddressLine2Updated: false,
            isCityUpdated: false,
            isStateUpdated: false,
            isZipUpdated: false,
            isEmailAddressUpdated: false,
            isIpAddressUpdated: false,
            isSSNUpdated: false,
            isOtherUpdated: false,
          }
        : {
            isFirstNameUpdated: selectedFields.includes("firstname"),
            isMiddleNameUpdated: selectedFields.includes("midname"),
            isLastNameUpdated: selectedFields.includes("lastname"),
            isPhoneNumberUpdated: selectedFields.includes("phone"),
            isAddressLine1Updated: selectedFields.includes("address1"),
            isAddressLine2Updated: selectedFields.includes("address2"),
            isCityUpdated: selectedFields.includes("city"),
            isStateUpdated: selectedFields.includes("state"),
            isZipUpdated: selectedFields.includes("zip"),
            isEmailAddressUpdated: selectedFields.includes("email"),
            isIpAddressUpdated: selectedFields.includes("ip"),
            isSSNUpdated: selectedFields.includes("ssn"),
            isOtherUpdated: selectedFields.includes("other"),
          };

    const customerUpdateData = {
      firstName: formValues.firstname || "",
      middleName: formValues.midname || "",
      lastName: formValues.lastname || "",
      phoneNumber: formValues.phone || "",
      addressLine1: formValues.address1 || "",
      addressLine2: formValues.address2 || "",
      city: formValues.city || "",
      state: formValues.state || "",
      zip: formValues.zip || "",
      emailAddress: formValues.email || "",
      ipAddress: formValues.ip || "",
      ssn: formValues.ssn || "",
      other: formValues.other || "",
    };

    const payload = {
      credenceAccountNumber: CredenceAccountNumber,
      action:
        actionType === "correct"
          ? "Update"
          : actionType === "delete"
            ? "Delete"
            : "Request Copy",
      requestCopy: formValues.RequestCopyDetail || "",
      customerUpdateFields,
      customerUpdateData,
    };

    try {
      api.post(`${apiUrl}/CustomerInformation`, payload).then((res) => {
        if (res.status == 200) {
          setSelectedFields([]);
          setFormValues({});
          setIsCCPAModalOpen(false);

          MySwal.fire({
            title: "Success!",
            text: "Request Sent Successfully.",
            icon: "success",
            confirmButtonText: "Ok",
          });
        } else {
          setIsCCPAModalOpen(false);
          MySwal.fire({
            title: "Error!",
            text: "Erro While Processing Your Request",
            icon: "error",
            confirmButtonText: "Ok",
          });
        }
      });
    } catch (error) {}
  };
  const shouldEnableButton = useMemo(() => {
    const isValidField = (fieldName) => {
      const value = formValues[fieldName];
      return value && String(value).trim() !== "";
    };

    const allSelectedFieldsHaveValues =
      Array.isArray(selectedFields) &&
      selectedFields?.length > 0 &&
      selectedFields.every(isValidField);

    if (actionType === "correct") {
      return Object.values(formValues).some(
        (val) => val && String(val).trim() !== "",
      );
    } else if (actionType === "delete") {
      return Array.isArray(selectedFields) && selectedFields?.length > 0;
    } else {
      const hasAnyValue = Object.values(formValues).some(
        (val) => val && String(val).trim() !== "",
      );
      return hasAnyValue;
    }
  }, [formValues, actionType, selectedFields]);
  useEffect(() => {
    setLoading(true);
    api
      .get(`${apiUrl}/CustomerInfo/${CredenceAccountNumber}`)
      .then((response) => {
        // console.log(response.data);
        // console.log("response1",response.data);

        if (response.status === 200) {
          setEmail(response.data.emailID);
          setPhone(response.data.phoneNumber);
          setOldEmail(response.data.emailID);
          setOldPhone(response.data.phoneNumber);
          setIsSubmitVisible(true);
        } else {
        }
      })
      .catch((error) => {
        // console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [CredenceAccountNumber, refresh]);
  const handleEconsentSubmit = () => {
    api
      .put(`${apiUrl}/EsignConsent`, {
        credenceAccountNumber: CredenceAccountNumber,
        esignFlag: true,
      })
      .then((response) => {
        if (response.status === 200) {
          //alert("E-sign consent submitted successfully");
          MySwal.fire({
            title: "Success!",
            text: "E-sign consent submitted successfully.",
            icon: "success",
            confirmButtonText: "Ok",
          });
          setIsEconsentModalOpen(false);
        } else {
          MySwal.fire({
            title: "Error!",
            text: "Something went wrong, please try again.",
            icon: "error",
            confirmButtonText: "Try Again",
          });
        }
      })
      .catch((error) => {});
  };

  const handleCustomerInfoUpdate = () => {
 setIsUpdateInfoOpenModel(false);
    const isEmailUpdated = UpdateData.emailID !== oldEmail;
    const isPhoneUpdated = UpdateData.phoneNumber !== oldPhone;


    setEmail(UpdateData.emailID);
    setPhone(UpdateData.phoneNumber);

    // console.log(UpdateData.emailID )
    // console.log(oldEmail)

    api
      .put(`${apiUrl}/CustomerInfo`, UpdateData)
      .then((response) => {
          //  console.log("response",response);

        if (response.status === 200) {
          setIsSubmitVisible(true);
          setRefresh(prev=>!prev);
           
          MySwal.fire({
            title: "Success!",
            text: "Details Updated Successfully.",
            icon: "success",
            confirmButtonText: "Ok",
          }).then((result)=>{
              if (isEmailUpdated) {
                // console.log("running")
          setIsEconsentModalOpen(true);
        }
          });

        
        } else {
          setEmail("");
          setPhone("");
          MySwal.fire({
            title: "Error!",
            text: "Something went wrong, please try again.",
            icon: "error",
            confirmButtonText: "Try Again",
          });
        }
      })
      .catch((error) => {});
  };
  useEffect(() => {
    api
      .get(`${apiUrl}/CustomerInformation/${CredenceAccountNumber}`)
      .then((response) => {
          // console.log("response",response.data);

        if (response.status === 200) {
          // console.log("response",response.data);
          setAccountInfo(response.data);
          setLoading(false);
          if (response.data.customerEmail && response.data.customerPhone) {
            setEmail(response.data.customerEmail);
            setPhone(response.data.customerPhone);
            setOldEmail(response.data.customerEmail);
            setOldPhone(response.data.customerPhone);
            setIsSubmitVisible(true);
            setSubmitDisabled(true);
          }
        } else {
        }
      })
      .catch((error) => {});
  }, [CredenceAccountNumber, refresh]);
  useEffect(() => {
    api.get(`${apiUrl}/CustomerRights/${CredenceAccountNumber}`).then((res) => {
      //console.log(res.data)
      setCustomerRights(res.data);
      //console.log(res.data);
    });
  }, [CredenceAccountNumber]);
  const handleRightsModalOpen = () => {
    setIsRightsModalOpenTwo(true);
  };
  const handleEconsentModalOpen = () => {
    setIsEconsentModalOpen(true);
  };
  const handleCloseEconsentModal = () => {
          setIsSubmitVisible(true);

    setIsEconsentModalOpen(false);
  };
  const handleSolModalOpen = () => {
    if (customerRights[0].soL_Notice) {
      setIsSolNoticeModalOpen(true);
    } else {
      setIsPrivacyOpenModel(true);
    }
    setIsSolNoticeModalOpen(true);
    setIsRightsModalOpenTwo(false);
  };
  const handlePrivacyOpenModel = () => {
    setIsPrivacyOpenModel(true);
    setIsSolNoticeModalOpen(false);
  };
  const handleCCPAModalOpen = () => {
    setIsCCPAModalOpen(true);
  };
  // useEffect(() => {
  //   const handleOutsideClickRightsModal = (e) => {
  //     if (
  //       rightsModalRefTwo.current &&
  //       !rightsModalRefTwo.current.contains(e.target)
  //     ) {
  //       setIsRightsModalOpenTwo(false);
  //     }
  //   };
  //   const handleSolModalClickOutside = (e) => {
  //     if (solModalRef.current && !solModalRef.current.contains(e.target)) {
  //       setIsSolNoticeModalOpen(false);
  //     }
  //   };

  //   const handleOutsideClickUpdateInfo = (e) => {
  //     if (updateInfoRef.current && !updateInfoRef.current.contains(e.target)) {
  //       setIsUpdateInfoOpenModel(false);
  //       setIsEmailError("");
  //       setIsPhoneError("");
  //     }
  //   };

  //   const handleOutsideClickEconsentInfo = (e) => {
  //     if (
  //       econsentInfoRef.current &&
  //       !econsentInfoRef.current.contains(e.target)
  //     ) {
  //       setIsEconsentModalOpen(false);
  //     }
  //   };

  //   if (isRightsModalOpenTwo) {
  //     document.addEventListener("mousedown", handleOutsideClickRightsModal);
  //   } else {
  //     document.removeEventListener("mousedown", handleOutsideClickRightsModal);
  //   }

  //   if (isUpdateInfoOpenModel) {
  //     document.addEventListener("mousedown", handleOutsideClickUpdateInfo);
  //   } else {
  //     document.removeEventListener("mousedown", handleOutsideClickUpdateInfo);
  //   }

  //   if (isEconsentModalOpen) {
  //     document.addEventListener("mousedown", handleOutsideClickEconsentInfo);
  //   } else {
  //     document.removeEventListener("mousedown", handleOutsideClickEconsentInfo);
  //   }
  //   if (isSolNoticeModalOpen) {
  //     document.addEventListener("mousedown", handleSolModalClickOutside);
  //   } else {
  //     document.removeEventListener("mousedown", handleSolModalClickOutside);
  //   }

  //   return () => {
  //     document.removeEventListener("mousedown", handleOutsideClickRightsModal);
  //     document.removeEventListener("mousedown", handleOutsideClickUpdateInfo);
  //     document.removeEventListener("mousedown", handleOutsideClickEconsentInfo);
  //     document.removeEventListener("mousedown", handleSolModalClickOutside);
  //   };
  // }, [isRightsModalOpenTwo, isUpdateInfoOpenModel, isEconsentModalOpen]);
  const handleRightModelTwoClose = () => {
    setIsRightsModalOpenTwo(false);
  };
  const handleRightModeClose = () => {
    setIsRightsModalOpen(false);
  };
  const handleUnsubscribe = () => {
          setIsSubmitVisible(true);

    api
      .put(`${apiUrl}/EsignConsent`, {
        credenceAccountNumber: CredenceAccountNumber,
        esignFlag: false,
      })
      .then((response) => {
     
        
        //console.log(response);
        if (response.status === 200) {
          setRefresh(prev=>!prev);
          //alert("E-sign consent Unsubscribed successfully");
          MySwal.fire({
            title: "Success!",
            text: "E-sign consent Unsubscribed successfully.",
            icon: "success",
            confirmButtonText: "Ok",
          });
          setIsEconsentModalOpen(false);
        } else {
          MySwal.fire({
            title: "Error!",
            text: "Something went wrong, please try again.",
            icon: "error",
            confirmButtonText: "Try Again",
          });
        }
      })
      .catch((error) => {
        //console.error("API error:", error);
        //alert("Error occurred, please try again.");
      }).finally(()=>{
             setIsSubmitVisible(true);
      });
  };
  return (
    <>
      {/* <div className="app-shell-with-header"> */}
        <main className="main-content">
          <div className="layout-container">
            <div className="layout-page">
              {loading ? (
                <ProfileSkeleton />
              ) : (
                <>
                  <section className="hero-account-section">
                    <div className="hero-content">
                      <div className="account-status-row">
                        <div className="account-title-group">
                          <h1>Account Overview</h1>
                          <p className="account-subtitle">
                            Overview of your account balance and details
                          </p>
                        </div>
                        {/* {paymentStatus ? (
                          <span className=" status-badge status-pending">
                            Payment In-Progress
                          </span>
                        ) : null} */}
                      </div>

                      <div className="hero-stats">
                        <div className="ac-stat-item">
                          <span className="stat-label">Balance</span>
                          <div className="stat-value balance">
                            ${AccountInfo.currentBalance.toFixed(2)}
                          </div>
                        </div>
                        <div className="ac-stat-item">
                          <span className="stat-label">
                            Credence Account Number
                          </span>
                          <div className="stat-value account-num">
                            {AccountInfo.credenceAccountNumber
                              ? AccountInfo.credenceAccountNumber.substring(
                                  0,
                                  2,
                                ) +
                                "****" +
                                AccountInfo.credenceAccountNumber.slice(-3)
                              : ""}
                          </div>
                        </div>
                      </div>

                      <div className="hero-actions">
                        <a href="/Payment" className="pf-btn btn-white">
                          <i className="bx bx-credit-card"></i>
                          Make Payment
                        </a>
                        <Link
                          to="/PaymentHistory"
                          className="pf-btn btn-outline-white"
                        >
                          <i className="bx bx-history"></i>
                          View History
                        </Link>
                      </div>
                    </div>
                  </section>

                  <div className="details-grid">
                    <div className="detail-card">
                      <div className="detail-card-header">
                        <h2 className="detail-card-title">Account Details</h2>
                      </div>

                      <div className="detail-card-content-container">
                        <div className="creditor-section">
                          <span className="creditor-label">
                            {AccountInfo?.collectionType === "DebtBuyer"
                              ? "Current Creditor"
                              : "Creditor"}
                          </span>

                          <div className="creditor-name">
                            {AccountInfo.creditorName}
                          </div>

                          {AccountInfo?.collectionType === "DebtBuyer" && (
                            <div className="original-creditor">
                              <strong>Original Creditor:</strong>{" "}
                              {AccountInfo.originalCreditorName}
                            </div>
                          )}
                        </div>

                        <div className="dates-container">
                          <div className="date-pill">
                            <i className="bx bx-calendar"></i>

                            <div className="date-content">
                              {AccountInfo?.channelFlag === "MEDICAL" && (
                                <>
                                  <span className="date-pill-label">
                                    Date of Service
                                  </span>
                                  <div className="date-pill-value">
                                    {formatDate(AccountInfo.dateOfService)}
                                  </div>
                                </>
                              )}

                              {AccountInfo?.channelFlag === "TELECOM" && (
                                <>
                                  <span className="date-pill-label">
                                    Disconnect Date
                                  </span>
                                  <div className="date-pill-value">
                                    {formatDate(AccountInfo.disconnectedDate)}
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="detail-card">
                      <div className="detail-card-header">
                        <h2 className="detail-card-title">Profile</h2>
                        <button
                          className="btn-edit-inline"
                          onClick={handleUpdateInfoOpenModel}
                        >
                          <i className="bx bx-edit-alt"></i>
                          Update
                        </button>
                      </div>
                      <div className="detail-card-content-container">
                        <div className="profile-info-list">
                          <div className="info-row">
                            <span className="info-row-label">Name</span>
                            <span className="info-row-value">
                              {AccountInfo.firstName +
                                " " +
                                AccountInfo.lastName}
                            </span>
                          </div>
                          <div className="info-row">
                            <span className="info-row-label">Email</span>
                            <span className="info-row-value">
                              {email || AccountInfo.email}
                            </span>
                          </div>
                          <div className="info-row">
                            <span className="info-row-label">Phone</span>
                            <span className="info-row-value">
                              {phone || AccountInfo.phone}{" "}
                            </span>
                          </div>
                          <div className="info-row">
                            <span className="info-row-label">Zip Code</span>
                            <span className="info-row-value">
                              {AccountInfo.zip?.length === 9
                                ? `${AccountInfo.zip.slice(
                                    0,
                                    5,
                                  )}-${AccountInfo.zip.slice(5)}`
                                : AccountInfo.zip}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <section className="preferences-section" id="prefernceItems">
                    <div className="preferences-header">
                      <h2>Privacy & Preferences</h2>
                      <p>
                        Manage your privacy settings and communication
                        preferences
                      </p>
                    </div>

                    <div className="preferences-grid">
                      {customerRights.length > 0 ? (
                        <div
                          className="preference-card"
                          onClick={handleRightsModalOpen}
                          role="button"
                          aria-label="Open Rights settings"
                          tabindex="0"
                        >
                          <div className="preference-left">
                            <div className="preference-icon">
                              <i className="bx bx-shield-alt-2"></i>
                            </div>
                            <span className="preference-text">Rights </span>
                          </div>
                          <i className="bx bx-chevron-right preference-arrow"></i>
                        </div>
                      ) : null}

                      {AccountInfo.state === "CA" ? (
                        <div
                          className="preference-card"
                          onClick={handleCCPAModalOpen}
                          role="button"
                          aria-label="Open Preferences" 
                          tabindex="0"
                        >
                          <div className="preference-left">
                            <div className="preference-icon">
                              <i className="bx bx-notepad"></i>
                            </div>
                            <span className="preference-text">Preferences</span>
                          </div>
                          <i className="bx bx-chevron-right preference-arrow"></i>
                        </div>
                      ) : null}

                      <div
                        className="preference-card"
                        onClick={handleEconsentModalOpen}
                        role="button"
                        aria-label="Open E-Consent form" 
                        tabindex="0"
                      >
                        <div className="preference-left">
                          <div className="preference-icon">
                            <i className="bx bx-recycle"></i>
                          </div>
                          <span className="preference-text">Go Green</span>
                        </div>
                        <i className="bx bx-chevron-right preference-arrow"></i>
                      </div>
                    </div>
                  </section>
                </>
              )}
            </div>
          </div>
        </main>
      {/* </div> */}
      {isRightsModalOpenTwo && (
        <div
          className={`modal fade show d-block notice-modal`}
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          // aria-hidden="true"
          style={{
            display: "block",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1501,
            transition: "opacity 0.3s ease-in-out",

            transitionDuration: "0.3s",
          }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content" ref={rightsModalRefTwo}>
              <div className="modal-header d-flex justify-content-between">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Your Rights
                </h1>

                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={handleRightModelTwoClose}
                  style={{
                    margin: "0",
                  }}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div
                      
                      dangerouslySetInnerHTML={{
                        __html: customerRights[0].regular_Notice,
                      }}
                    />
                  </div>
                  <div className="col-md-12">
                    <div
                      
                      dangerouslySetInnerHTML={{
                        __html: customerRights[0].soL_Notice,
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer justify-content-center">
                {customerRights[0].privacyFlag ? (
                  <a
                    href={
                      AccountInfo.state === "CA"
                        ? "/Privacy-Policy#link-24"
                        : [
                              "CO",
                              "CT",
                              "DE",
                              "IA",
                              "MT",
                              "NE",
                              "NH",
                              "NJ",
                              "OR",
                              "TX",
                              "UT",
                              "VA",
                            ].includes(AccountInfo.state)
                          ? "/Privacy-Policy#link-25"
                          : "/Privacy-Policy"
                    }
                    target="blank"
                  >
                    Privacy Policy
                  </a>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {isCCPAModalOpen && AccountInfo.state === "CA" && (
        // <div
        //   className={`modal fade show d-block notice-modal`}
        //   tabIndex="-1"
        //   aria-labelledby="exampleModalLabel"
        //   style={{
        //     display: "block",
        //     position: "fixed",
        //     top: 0,
        //     left: 0,
        //     width: "100%",
        //     height: "100%",
        //     backgroundColor: "rgba(0, 0, 0, 0.5)",
        //     zIndex: 1501,
        //     transition: "opacity 0.3s ease-in-out",

        //     transitionDuration: "0.3s",
        //   }}
        // >
        //   <div className="modal-dialog modal-fullscreen modal-dialog-scrollable">
        //     <div className="modal-content" ref={updateRequestModelRef}>
        <div
          className={`modal fade show  d-block notice-modal`}
          tabIndex="-1"
          // aria-hidden="true"
          style={{
            display: "block",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1501,
            transition: "opacity 0.3s ease-in-out",

            transitionDuration: "0.3s",
          }}
        aria-labelledby="CaliforniaPrivacyWebform" 
        >
          <div className="modal-dialog modal-fullscreen modal-dialog-scrollable">
            <div className="modal-content" ref={updateRequestModelRef}>
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  California Privacy Web Form
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={handleUpdateRequestCloseModel}
                ></button>
              </div>
              <div className="modal-body">
                <div className="request-section p-2">
                  {/* Take Action Section */}
                  <div className="Request-action-section mb-3">
                    <h5 className="label ms-1">
                      Select the Right You Want to Exercise
                    </h5>
                    <div className="row">
                      {["correct", "delete", "requestcopy"].map((type) => (
                        <div className="col-md-4 mb-2" key={type}>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="actionType"
                              id={`${type}Check`}
                              value={type}
                              checked={actionType === type}
                              onChange={handleActionChange}
                            />
                            <label
                              className="form-check-label form-label"
                              htmlFor={`${type}Check`}
                            >
                              {type === "correct"
                                ? "Correct my information"
                                : type === "requestcopy"
                                  ? "Request information copy"
                                  : "Delete my information"}
                            </label>
                          </div>
                        </div>
                      ))}
                    </div>
                    <hr className="mt-0 mb-2" />
                  </div>

                  {/* Correct / Delete Fields Selection */}
                  {actionType === "correct" && (
                    <div className="correct-field mb-3">
                      <h5 className="label ms-1">
                        Update the information you want to correct
                      </h5>
                      <div className="row">
                        {Object.entries(fieldsMap).map(([fieldKey, field]) => {
                          if (fieldKey === "other") {
                            return (
                              <div className="col-md-4 mb-3" key={fieldKey}>
                                <label
                                  htmlFor="otherInput"
                                  className="form-label"
                                >
                                  Other
                                </label>
                                <textarea
                                  ref={(el) => setInputRef("other", el)}
                                  className="form-control"
                                  name="ForOther"
                                  id="otherInput"
                                  rows="3"
                                  placeholder="Specify Here"
                                  value={formValues["other"] || ""}
                                  onChange={(e) =>
                                    handleInputChangeForFields(
                                      "other",
                                      e.target.value,
                                    )
                                  }
                                />
                              </div>
                            );
                          }

                          return (
                            <div
                              className="col-12 col-sm-6 col-md-4 mb-3"
                              key={fieldKey}
                            >
                              <label
                                htmlFor={`${fieldKey}Input`}
                                className="form-label"
                              >
                                {field.label}
                              </label>
                              <input
                                ref={(el) => setInputRef(fieldKey, el)}
                                className="form-control"
                                type={field.type}
                                name={field.name}
                                id={`${fieldKey}Input`}
                                placeholder={field.placeholder}
                                value={formValues[fieldKey] || ""}
                                onChange={(e) =>
                                  handleInputChangeForFields(
                                    fieldKey,
                                    e.target.value,
                                  )
                                }
                              />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {/* Delete Fields Selection - Show checkboxes */}
                  {actionType === "delete" && (
                    <div className="delete-selection mb-3">
                      <h5 className="label ms-1">
                        Select the information you want to delete
                      </h5>
                      <div className="row">
                        {fieldOptions
                          .filter((opt) => opt.value !== "all")
                          .map((field) => (
                            <>
                              <div className="col-md-3" key={field.value}>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`delete-${field.value}`}
                                    value={field.value}
                                    checked={selectedFields.includes(
                                      field.value,
                                    )}
                                    onChange={(e) => {
                                      const { checked, value } = e.target;
                                      setSelectedFields((prev) =>
                                        checked
                                          ? [...prev, value]
                                          : prev.filter((f) => f !== value),
                                      );
                                    }}
                                  />
                                  <label
                                    className="form-check-label form-label"
                                    htmlFor={`delete-${field.value}`}
                                  >
                                    {field.label}
                                  </label>
                                </div>
                              </div>

                              {field.value === "other" &&
                              selectedFields.includes("other") ? (
                                <div className="col-md-12">
                                  <textarea
                                    className="form-control"
                                    name="RequestCopyDetail"
                                    id="DeleteCopy"
                                    rows="3"
                                    placeholder="Specify Here you want to delete"
                                    value={formValues["other"] || ""}
                                    onChange={(e) =>
                                      handleInputChangeForFields(
                                        "other",
                                        e.target.value,
                                      )
                                    }
                                  />
                                </div>
                              ) : (
                                <></>
                              )}
                            </>
                          ))}
                      </div>
                    </div>
                  )}

                  {/* Correct/Delete Fields Inputs */}
                  {actionType === "correct" && (
                    <div className="correct-delete-field mb-3">
                      <div className="row">
                        {selectedFields.map((fieldKey) => {
                          const field = fieldsMap[fieldKey];
                          if (!field) return null;
                          if (fieldKey === "other") {
                            return (
                              <div className="col-md-6 mb-3" key={fieldKey}>
                                <label
                                  htmlFor="otherInput"
                                  className="form-label"
                                >
                                  Other <span className="text-danger">*</span>
                                </label>
                                <textarea
                                  ref={(el) => setInputRef("other", el)}
                                  className="form-control"
                                  name="ForOther"
                                  id="otherInput"
                                  cols="30"
                                  rows="3"
                                  placeholder="Specify Here"
                                  value={formValues["other"] || ""}
                                  onChange={(e) =>
                                    handleInputChangeForFields(
                                      "other",
                                      e.target.value,
                                    )
                                  }
                                ></textarea>
                              </div>
                            );
                          }
                          return (
                            <div className="col-md-6 mb-3" key={fieldKey}>
                              <label
                                htmlFor={`${fieldKey}Input`}
                                className="form-label"
                              >
                                {field.label}{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                ref={(el) => setInputRef(fieldKey, el)}
                                className="form-control"
                                type={field.type}
                                name={field.name}
                                id={`${fieldKey}Input`}
                                placeholder={field.placeholder}
                                value={formValues[fieldKey] || ""}
                                onChange={(e) =>
                                  handleInputChangeForFields(
                                    fieldKey,
                                    e.target.value,
                                  )
                                }
                              />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {/* Request Copy Field */}
                  {actionType === "requestcopy" && (
                    <div className="requestcopy-field mb-3">
                      <h5 className="label ms-1">
                        Request a copy of my information{" "}
                        <span className="text-danger">*</span>
                      </h5>
                      <div className="row">
                        <div className="col-md-12">
                          <textarea
                            ref={(el) => setInputRef("RequestCopyDetail", el)}
                            className="form-control"
                            name="RequestCopyDetail"
                            id="RequestCopyDetail"
                            rows="3"
                            placeholder="Specify Here"
                            value={formValues.RequestCopyDetail || ""}
                            onChange={(e) => {
                              handleInputChangeForFields(
                                "RequestCopyDetail",
                                e.target.value,
                              );
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Submit Button */}
                  {/* {actionType && (
      <div className="row">
        <div className="col-md-12 text-end">
          <button
            className="btn btn-primary"
            type="button"
            id="request-button"
            onClick={handleSubmit}
            disabled={!shouldEnableButton}
          >
            Submit
          </button>
        </div>
      </div>
    )} */}
                </div>
              </div>
              <div className="modal-footer d-flex">
                <button
                  type="button"
                  className="btn btn-outline"
                  data-bs-dismiss="modal"
                  onClick={handleUpdateRequestCloseModel}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary flex-shrink-0"
                  id="request-button"
                  onClick={handleSubmit}
                  disabled={!shouldEnableButton}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {isSolNoticeModalOpen && (
        <div
          className={`modal fade show  d-block notice-modal`}
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          //aria-hidden="true"
          style={{
            display: "block",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1501,
            transition: "opacity 0.3s ease-in-out",
            transitionDuration: "0.3s",
          }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content" ref={solModalRef}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12 border-bottom">
                    <div
                      className="xxxsmall"
                      dangerouslySetInnerHTML={{
                        __html: customerRights[0].soL_Notice,
                      }}
                    />
                  </div>
                  {customerRights[0].privacy_Link ? (
                    <div className="col-md-12">
                      <div className="d-flex mt-2 justify-content-center">
                        <a
                          href="#"
                          onClick={handlePrivacyOpenModel}
                          className="text-primary me-3 label"
                        >
                          {customerRights[0].privacy_Link ? "Privacy Link" : ""}
                        </a>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Your Rights Modal Two */}
      {isRightsModalOpen && (
        <div
          className={`modal fade show  d-block notice-modal`}
          tabIndex="-1"
          
         aria-labelledby="Your Rights Section"
          // aria-hidden="true"
          style={{
            display: "block",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1501,
            transition: "opacity 0.3s ease-in-out",
            transitionDuration: "0.3s",
          }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content" ref={rightsModalRefTwo}>
              <div className="modal-body">
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={handleRightModeClose}
                    style={{
                      margin: "0",
                    }}
                  ></button>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div
                      className="xxxsmall"
                      dangerouslySetInnerHTML={{
                        __html: customerRights[0].regular_Notice,
                      }}
                    />
                  </div>
                  <div className="col-md-12">
                    <div
                      className="xxxsmall"
                      dangerouslySetInnerHTML={{
                        __html: customerRights[0].soL_Notice,
                      }}
                    />
                  </div>
                  <br />
                  <br />
                  {customerRights[0].privacyFlag ? (
                    <div className="col-md-12 border-top">
                      <div className="d-flex mt-2 justify-content-center">
                        <a
                          href={
                            AccountInfo.state === "CA"
                              ? "/Privacy-Policy#link-24"
                              : [
                                    "CO",
                                    "CT",
                                    "DE",
                                    "IA",
                                    "MT",
                                    "NE",
                                    "NH",
                                    "NJ",
                                    "OR",
                                    "TX",
                                    "UT",
                                    "VA",
                                  ].includes(AccountInfo.state)
                                ? "/Privacy-Policy#link-25"
                                : "/Privacy-Policy"
                          }
                          target="blank"
                          style={{ textDecoration: "none" }}
                        >
                          Privacy Policy
                        </a>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}{" "}
      {isUpdateInfoOpenModel && (
        <div
          className={`modal fade show d-block`}
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          style={{
            display: "block",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1501,
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            ref={updateInfoRef}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Verify your details
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleUpdateInfoCloseModel}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <label htmlFor="" className="form-label">
                      Phone Number
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      name="UserPhone"
                      value={phone}
                      placeholder="Enter Phone Number"
                      maxLength={10}
                      minLength={10}
                      onChange={handleInputChange}
                      required
                    />
                    <div className="Error-msg">
                      <span className="text-danger">{isPhoneError}</span>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <label htmlFor="" className="form-label">
                      Email Address
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      name="UserEmail"
                      value={email}
                      placeholder="Enter E-mail Address"
                      required
                      onChange={handleInputChange}
                    />
                    <div className="Error-msg">
                      <span className="text-danger">{isEmailError}</span>
                    </div>
                  </div>
                  <div className="col-md-12 mt-3">
                    <div className="email-disclaimer px-3 py-2 ">
                      <div className="d-flex align-items-center gap-3">
                        <i className="bx bx-info-circle"></i>
                        <p className="xxxsmall fw-m text-balance">
                          Use a personal email address; work emails may be
                          accessible to third parties
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer d-flex">
                <a
                  href="#"
                  className="flex-grow-1 label"
                  onClick={() => {
                    setIsUpdateInfoOpenModel(false);
                    setIsEconsentModalOpen(true);
                    setIsEmailError("");
                    setIsPhoneError("");
                  }}
                >
                  It's correct
                </a>
                <button
                  type="button"
                  className="btn btn-primary flex-shrink-0"
                  disabled={isSubmitVisible}
                  onClick={() => {
                   
                    handleCustomerInfoUpdate();
                  }}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {isEconsentModalOpen && (
        <div
          className={`modal fade show d-block`}
          tabIndex="-1"
         aria-labelledby="E-ConsentForm" 
          style={{
            display: "block",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1501,
          }}
        >
          <div
            className="modal-dialog modal-fullscreen modal-dialog-centered  modal-lg modal-dialog-scrollable"
            ref={econsentInfoRef}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="">E-sign consent</h4>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseEconsentModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <p className="xxsmall mb-2">
                      Please consider how you would like documents associated
                      with your account(s) delivered. Unless you click on the
                      below link and provide your consent, we will send all
                      required documents to you via postal mail.
                    </p>
                    <ul className=" xxsmall ps-3 mb-0">
                      <li className="xxsmall">
                        If you are interested in electronic document delivery,
                        the law requires that we provide certain information to
                        you and obtain your consent to use an electronic
                        delivery process.
                      </li>
                      <li className="xxsmall">
                        {" "}
                        By providing your email address, you authorize Credence
                        Resource Management, LLC to send future correspondence,
                        including any required disclosures, by email regarding
                        your account(s) placed with us as of &nbsp;
                        <span className="fw-b">
                          {/* {AccountInfo.accountOpenDate || " 05/02/2025 "} */}
                          { formattedDate}
                        </span>
                        , and confirm that the email address you provided is not
                        an email account furnished or owned by your employer and
                        that there are no users other than yourself using the
                        provided email address.
                      </li>
                      <li className="xxsmall">
                        {" "}
                        Please note that if you provide access to your email
                        account to any other person, such person may be able to
                        read the emails we send to you.
                      </li>
                      <li className="xxsmall">
                        {" "}
                        To opt out from receiving future emails, click{" "}
                        <a
                          href="#"
                          className="text-burgundy fw-sb"
                          onClick={handleUnsubscribe}
                        >
                          HERE
                        </a>{" "}
                        to unsubscribe.
                      </li>
                      <li className="xxsmall">
                        {" "}
                        If calling, please reference the email address relevant
                        to your request.
                      </li>
                      <li className="xxsmall">
                        {" "}
                        We still may send some communications by postal mail.
                      </li>
                      <li className="xxsmall">
                        To view electronic attachments we may send, you must
                        have software which permits you to receive and access
                        PDF files, such as a basic version of Adobe Acrobat
                        Reader and above.
                      </li>
                      <li className="xxsmall">
                        You may retain copies of any emails and attachments we
                        send by downloading them to your personal device. You
                        can obtain a paper copy of any email or attachment from
                        us by printing it from your device, or you may ask us to
                        send you a copy at no cost.
                      </li>
                      <li className="xxsmall">
                        If you request a paper document but do not withdraw your
                        electronic delivery consent through the methods
                        described, we will not treat the request solely for a
                        paper document as a withdrawal of consent to electronic
                        delivery of documents. A withdrawal of electronic
                        delivery consent does not apply to a document that was
                        provided electronically before the date on which the
                        withdrawal of consent takes effect.
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-12 text-center">
                    <a
                      href="#"
                      className="xxsmall text-burgundy fw-sb"
                      onClick={handleUnsubscribe}
                    >
                      Unsubscribe Link
                    </a>
                  </div>
                </div>
              </div>
              <div className="modal-footer justify-content-between">
                <button
                  type="button"
                  className="btn btn-outline "
                  onClick={handleCloseEconsentModal}
                >
                  Skip for Now
                </button>
                <button
                  type="button"
                  className="btn btn-primary "
                  onClick={handleEconsentSubmit}
                >
                  I Consent
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const InfoItem = ({ label, value }) => (
  <div className="info-item">
    <span className="info-label">{label}</span>
    <span className="info-value">{value}</span>
  </div>
);

export default Profile;
